import Immutable from 'immutable';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { setOperationStatus } from '@uncinc/react-drupal-core';
import useTypedDispatch from './useTypedDispatch';

type OperationStatus =
  'UI_OPERATION_STATUS_ERROR' |
  'UI_OPERATION_STATUS_REQUEST' |
  'UI_OPERATION_STATUS_SUCCESS' |
  null;

export default function useOperationStatus(type: string, operation: string) {
  const dispatch = useTypedDispatch();

  const operationStatus = useSelector<Immutable.Map<string, OperationStatus>, OperationStatus>(
    // type of state is coerced to ensure no error from eslint
    // So this is not necessarily accurate or true
    (state) => state.getIn(['ui', type, 'operations', operation, 'status'], null) as OperationStatus,
  );

  // Reset operation status when unloading.
  useEffect(() => {
    setOperationStatus(type, operation, null);
  }, [dispatch, operation, type]);

  return operationStatus;
}
